import React, { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import { Breadcrumbs, Form, Page } from "components";
import { inhabitantsAPI } from "services/inhabitantsAPI";
import { Button } from "../../components";
import FileUploader from "../../components/FileUploader";

import "./styles.scss";

export default function CreateCashback(props) {
  const previousPage = props.location.pathname.replace("create", "list");

  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "PRO", to: "/pro" },
    {
      name: "Listagem de Cashbacks",
      to: previousPage,
    },
    { name: "Inclusão de Cashbacks", to: "" },
  ];

  const [selectedFile, setSelectedFile] = useState(null);
  const [importing, setImporting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    setImporting(true);

    const formData = new FormData();
    formData.append("inhabitants", selectedFile);

    inhabitantsAPI
      .post("/cashbacks/values/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
          "Accept-Language": "pt-BR",
        },
      })
      .then(({ data: { data } }) => {
        const processorId = data.id;
        return props.history.push(
          `/processes/${processorId}/show`
        )
      })
      .catch(() => {
        swal({
          title: "Erro!",
          text: "Ocorreu um erro ao importar os dados. Tente novamente.",
          icon: "error",
          button: "Ok",
        });
      })
      .finally(() => {
        setImporting(false);
      });
  };

  return (
    <Page>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <Form className="container-add-pro" onSubmit={handleSubmit}>
        <header>
          <Page.Title>Inclusão de Cashbacks</Page.Title>
        </header>

        <div className="csv-file-cpf">
          <FileUploader
            type="cashback"
            readUploadFile={({ target }) => setSelectedFile(target.files[0])}
            isManual={false}
          />
        </div>

        <div className="buttons">
          <Link to={previousPage}>
            <Button className="back-btn" btnName="Voltar" type="button" />
          </Link>

          {!importing || !selectedFile ? (
            <Button
              className="save-btn"
              btnName="Salvar"
              type="submit"
              disabled={!selectedFile || importing}
            />
          ) : (
            <Button
              className="save-btn"
              btnName="Salvando..."
              disabled={!selectedFile || importing}
            />
          )}
        </div>
      </Form>
    </Page>
  );
}
